const normalizeSmsCode = (value) => {
    const code = typeof value === "number" ? String(value) : value;

    return typeof code === "string" && /^\d{6}$/.test(code.trim())
        ? code.trim()
        : "";
};

const extractDevelopmentSmsCode = (payload = {}) => {
    const candidates = [payload.data, payload.result, payload];
    const fieldNames = [
        "smsCode",
        "sms_code",
        "verificationCode",
        "verification_code",
        "code",
    ];

    for (const candidate of candidates) {
        const directCode = normalizeSmsCode(candidate);
        if (directCode) {
            return directCode;
        }

        if (!candidate || typeof candidate !== "object") {
            continue;
        }

        for (const fieldName of fieldNames) {
            const code = normalizeSmsCode(candidate[fieldName]);
            if (code) {
                return code;
            }
        }
    }

    return "";
};

module.exports = {
    extractDevelopmentSmsCode,
};
